import fetcher from './fetcher';

export const SWR_ERROR_RETRY_COUNT = 1;
export const SWR_ERROR_RETRY_INTERVAL = 5000;

function getErrorStatus(error) {
  return error?.response?.status ?? error?.status;
}

export function shouldRetryOnSWRFetchError(error) {
  const status = getErrorStatus(error);

  if (!status) return true;

  return status >= 500 && status !== 501;
}

export const swrConfig = {
  fetcher,
  shouldRetryOnError: shouldRetryOnSWRFetchError,
  errorRetryCount: SWR_ERROR_RETRY_COUNT,
  errorRetryInterval: SWR_ERROR_RETRY_INTERVAL,
  revalidateOnFocus: false,
};
